import {ShapeCommand} from '../commands.template';
import * as _ from 'lodash';
import {EventEmitter} from '@angular/core';
import {KEYS_TO_SANITIZE} from '../../shared/constants/keys-to-sanitize.constants';
import {AttachmentType} from '@q9elements/ui-kit/common';

export class ActivityChangeAttachmentCommand extends ShapeCommand {
  services: any;
  firstAction: boolean;
  reverseObject: any;
  eventCb: EventEmitter<boolean>;
  constructor(data) {
    super(data);
  }

  public prepareData(cb?: EventEmitter<boolean>) {
    let attachmentListKey: string;
    const activityJson = this.services.jsonHandlerSvc.get().activities.find(a => {
      return Number(a.mxKey) === Number(this.object.itemMxKey);
    });

    if (this.object.refModel) {
      attachmentListKey = 'refModelAttachments';
    } else if (this.object.requirement) {
      attachmentListKey = 'requirementAttachments';
    } else if (this.object.story) {
      attachmentListKey = 'storyAttachments';
    } else if (this.object.sfNode) {
      attachmentListKey = 'orgModelAttachments';
    } else {
      attachmentListKey = 'attachments';
    }

    const index = _.findIndex(activityJson[attachmentListKey], (chr: any) => {
      return Number(chr.mxKey) === Number(this.object.mxKey);
    });
    const attachment = activityJson[attachmentListKey][index];

    this.reverseObject = {
      title: attachment.title,
      value: attachment.value,
      groups: attachment.groups || [],
      itemMxKey: Number(this.object.itemMxKey),
      mxKey: this.object.mxKey,
      description: attachment.description || '',
      position: this.object.oldPosition,
      refModel: this.object.refModel,
      requirement: this.object.requirement,
      story: this.object.story,
      sfNode: this.object.sfNode,
      viewersCanAddRecords: this.object.viewersCanAddRecords,
      savedOnS3: this.object.savedOnS3,
      content: this.object.content,
      oldContent: this.object.previousValue,
      noteProItems: this.object.noteProItems,
      imagesForDelete: this.object.imagesForDelete,
      displayInUserHelp: this.object.displayInUserHelp,
      displayInUserHelpClassic: this.object.displayInUserHelpClassic,
      pushedAsSfHelpDate: this.object.pushedAsSfHelpDate,
      lastModifiedBy: (attachment.lastModifiedBy && attachment.lastModifiedBy.toString()) || null
    };

    if (cb) {
      this.eventCb = cb;
    }

    return this;
  }

  public execute() {
    let action;
    const param = {
      itemMxKey: this.object.itemMxKey,
      mxKey: this.object.mxKey,
      title: this.object.title,
      value: this.object.value,
      groups: this.object.groups,
      description: this.object.description,
      position: this.object.position,
      viewersCanAddRecords: this.object.viewersCanAddRecords,
      content: this.object.content,
      savedOnS3: this.object.savedOnS3,
      noteProItems: this.object.noteProItems,
      imagesForDelete: this.object.imagesForDelete,
      displayInUserHelp: this.object.displayInUserHelp,
      displayInUserHelpClassic: this.object.displayInUserHelpClassic,
      pushedAsSfHelpDate: this.object.pushedAsSfHelpDate
    };

    this.services.sanitizeXssService.sanitizeXss(param, KEYS_TO_SANITIZE.ATTACHMENT);

    if (this.object.refModel) {
      action = {changeRefModelAttachment: param};
    } else if (this.object.requirement) {
      action = {changeRequirementAttachment: param};

      return this.reorderRequirementsOrStories(action);
    } else if (this.object.story) {
      action = {changeStoryAttachment: param};

      return this.reorderRequirementsOrStories(action);
    } else if (this.object.sfNode) {
      action = {changeOrgModelAttachment: param};
    } else {
      action = {changeAttachment: param};
    }

    const isUrlAttachment =
      this.object.type === AttachmentType.URL || this.object.type === AttachmentType.URL_ENTRY;

    if (isUrlAttachment) {
      return this.services.diagramUpdateSvc
        .update(action, true, true, false, this.eventCb)
        .then(() => {
          this.services.jsonHandlerSvc.update(action);
        });
    }

    return this.services.diagramUpdateSvc.update(action, false, false, false, this.eventCb);
  }

  public reverse() {
    let action;
    const param = {
      itemMxKey: this.reverseObject.itemMxKey,
      mxKey: this.reverseObject.mxKey,
      title: this.reverseObject.title,
      value: this.reverseObject.value,
      groups: this.reverseObject.groups,
      description: this.reverseObject.description,
      position: this.reverseObject.position,
      content: this.reverseObject.oldContent,
      savedOnS3: this.reverseObject.savedOnS3,
      noteProItems: this.object.noteProItems,
      imagesForDelete: this.object.imagesForDelete,
      displayInUserHelp: this.object.displayInUserHelp,
      displayInUserHelpClassic: this.object.displayInUserHelpClassic,
      pushedAsSfHelpDate: this.object.pushedAsSfHelpDate,
      lastModifiedBy: this.reverseObject.lastModifiedBy
    };

    if (this.reverseObject.refModel) {
      action = {changeRefModelAttachment: param};
    } else if (this.reverseObject.requirement) {
      action = {changeRequirementAttachment: param};

      return this.reorderRequirementsOrStories(action);
    } else if (this.reverseObject.story) {
      action = {changeStoryAttachment: param};

      return this.reorderRequirementsOrStories(action);
    } else if (this.reverseObject.sfNode) {
      action = {changeOrgModelAttachment: param};
    } else {
      action = {changeAttachment: param};
    }

    return this.services.diagramUpdateSvc.update(action);
  }

  private reorderRequirementsOrStories(action) {
    return this.services.diagramUpdateSvc.update(action, true, true).then(result => {
      this.services.jsonHandlerSvc.update(action);

      // this.redrawActivity(this.object.itemMxKey);
      return result;
    });
  }
}
